import docCookies from 'doc-cookies';

export default () => ({
  open: false,

  close() {
    this.open = false;
    docCookies.setItem('brochure-popup', false, 60 * 60 * 24 * 14);
  },

  init() {
    const cookie = docCookies.getItem('brochure-popup');
    if (cookie == null) {
      setTimeout(() => {
        this.open = true;
        docCookies.setItem('brochure-popup', true, 60 * 60 * 24 * 14);
      }, 9000);
    } else if (cookie == 'true') {
      this.open = true;
    }
  },
});
